// extracted by mini-css-extract-plugin
export var grid = "_27-0";
export var span1 = "_27-2";
export var span10 = "_27-b";
export var span10L = "_27-z";
export var span10M = "_27-n";
export var span10Xl = "_27-1b";
export var span11 = "_27-c";
export var span11L = "_27-10";
export var span11M = "_27-o";
export var span11Xl = "_27-1c";
export var span12 = "_27-d";
export var span12L = "_27-11";
export var span12M = "_27-p";
export var span12Xl = "_27-1d";
export var span1L = "_27-q";
export var span1M = "_27-e";
export var span1Xl = "_27-12";
export var span2 = "_27-3";
export var span2L = "_27-r";
export var span2M = "_27-f";
export var span2Xl = "_27-13";
export var span3 = "_27-4";
export var span3L = "_27-s";
export var span3M = "_27-g";
export var span3Xl = "_27-14";
export var span4 = "_27-5";
export var span4L = "_27-t";
export var span4M = "_27-h";
export var span4Xl = "_27-15";
export var span5 = "_27-6";
export var span5L = "_27-u";
export var span5M = "_27-i";
export var span5Xl = "_27-16";
export var span6 = "_27-7";
export var span6L = "_27-v";
export var span6M = "_27-j";
export var span6Xl = "_27-17";
export var span7 = "_27-8";
export var span7L = "_27-w";
export var span7M = "_27-k";
export var span7Xl = "_27-18";
export var span8 = "_27-9";
export var span8L = "_27-x";
export var span8M = "_27-l";
export var span8Xl = "_27-19";
export var span9 = "_27-a";
export var span9L = "_27-y";
export var span9M = "_27-m";
export var span9Xl = "_27-1a";
export var stretch = "_27-1";